module.exports = __webpack_public_path__ + "img/active_8.8beee524.png";